import classNames from 'classnames';
import { MouseEvent } from 'react';
import './Switch.scss';
import ISwitchProps from './SwitchProps';

const Switch = ({ onChange, value, disabled, className }: ISwitchProps) => {
  const classes = classNames(
    {
      'switch': true,
      disabled,
      'switch-on': value,
    },
    className
  );

  function handleClick(_event: MouseEvent) {
    if (!disabled) {
      onChange(!value);
    }
  }

  return (
    <div className={classes} onClick={handleClick}>
      <div className="switch-bar">
        <span className="switch-knob" />
      </div>
    </div>
  );
};

Switch.defaultProps = {
  value: false,
  disabled: false,
};

export default Switch;
